import React from 'react';
import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { 
//     handle_Authenticate, 
//     handle_signedIn, 
//     handle_auth_user, 
// } from '../../Redux/reducer';
import {
    handleMessageUs,
} from '../../Redux/actions';

//Icons
import SendIcon from '@material-ui/icons/Send';

export const MessageUs = () => {
  
  const dispatch = useDispatch();

    // References
  const usernameRef = useRef();
  const emailRef = useRef();
  const phoneNumberRef = useRef();
  const messageRef = useRef();

  //MessageUs Final Function
  const handleMessageUsSubmit = (e) => {
    e.preventDefault();
    const user = {
      userName: usernameRef.current.value,
      email: emailRef.current.value,
      phoneNumber: phoneNumberRef.current.value,
      message: messageRef.current.value,
      date: new Date(),
    };
    if (
      usernameRef.current.value == "" ||
      emailRef.current.value == "" ||
      phoneNumberRef.current.value  == "" ||
      messageRef.current.value  == ""
    ) {
        // console.log("MessageUs:handleMessageUsSubmit: Please fill all the fields");
        window.alert("Please fill all the fields in message us")
    } else {
        dispatch(handleMessageUs(user));
    }
  };
  //MessageUs on enter-press
  const enterMessageUsPressed = (event) => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      handleMessageUsSubmit(event);
      //13 is the enter keycode
      //Do stuff in here
    }
  };

    return(
        <div>
            <div className='home-contact-message-form-title'>
                Message us
              </div>
              <form onSubmit={handleMessageUsSubmit} onKeyPress={enterMessageUsPressed}>
                <input 
                    type='text' 
                    placeholder="Name" 
                    className='name-ip'
                    required
                    ref={usernameRef}
                /><br></br>
                <input 
                    type='email' 
                    placeholder="E-Mail" 
                    className='email-ip'
                    required
                    ref={emailRef}
                /><br></br>
                <input 
                    type='number' 
                    placeholder="Phone Number" 
                    className='phone-ip'
                    required
                    ref={phoneNumberRef}
                /><br></br>
                <textarea 
                    type='text' 
                    placeholder="Message" 
                    className="message-ip" 
                    cols='70'
                    required
                    ref={messageRef}
                /><br></br>
                <button className='home-contact-message-send-btn' type={"submit"}>
                    <SendIcon />
                </button>
              </form>
        </div>
    )
}

export default MessageUs;
